module.exports = __webpack_public_path__ + "static/img/4en.8acac40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/huawei/4en.png
// module id = CUnS
// module chunks = 0